<template>
  <div id="b2b-facet" class="b2b-plp-sidebar" data-transition="overlap">
    <facets-header
      :title="$t('search.nav.refinements')"
      :heading-level="2"
      :is-open="isShowingFilters"
      :selected-filters="selectedFilters"
      @toggle-state="toggleFiltersState"
    />
    <selected-facets
      v-if="selectedFilters && selectedFilters.length > 0"
      v-show="isShowingFilters"
      :filters="selectedFilters"
      @state-changed="updateFilter"
    />
    <div v-if="filters && filters.length > 0" v-show="isShowingFilters">
      <ul class="facet-group__list">
        <facet-item
          v-for="(filter, i) in filters"
          :key="`filter-${i}`"
          :name="`filter-${i}`"
          :item-id="`filter-${i}-${locationId}`"
          :value="filter"
          @state-changed="updateFilter"
        />
      </ul>
    </div>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState, mapGetters} from 'vuex';
import FacetsHeader from './PlpFacets/FacetsHeader';
import FacetItem from './PlpFacets/FacetItem';
import SelectedFacets from './PlpFacets/SelectedFacets';
import {ViewSize} from '@/constants/view-breakpoints';

export default {
  components: {
    FacetsHeader,
    FacetItem,
    SelectedFacets,
  },
  props: {
    filters: {
      type: [Array, Object],
      default: () => [],
    },
    selectedFilters: {
      type: [Array, Object],
      default: () => [],
    },
    locationId: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState('plp', ['areFiltersVisible']),
    ...mapGetters('viewSize', ['viewBreakpointMoreThan']),
    isShowingFilters() {
      return this.areFiltersVisible || this.viewBreakpointMoreThan(ViewSize.MEDIUM);
    },
  },
  methods: {
    ...mapMutations('plp', ['setAreFiltersVisible']),
    ...mapActions('plp', {
      updateFilter: 'updateFilter',
    }),
    toggleFiltersState() {
      this.setAreFiltersVisible(!this.areFiltersVisible);
    },
  },
};
</script>
